import React from 'react';
import PropTypes from 'prop-types';
import { DataTable } from '@getro/rombo';
import { useApiKeysData } from '../hooks/useApiKeysData';

export const ApiKeysDataTable = ({ apiKeys, onClickRevoke }) => {
  const { columns, rows } = useApiKeysData({
    apiKeys,
    onClickRevoke,
  });

  return (
    <DataTable
      sx={{
        width: '100%',
        flexGrow: 1,

        '[role="columnheader"]': {
          alignSelf: 'flex-end',
          justifyContent: 'flex-start',
        },
      }}
      virtuosoProps={{
        useWindowScroll: true,
      }}
      items={rows}
      columnDefinition={columns}
      isInitialized
      hasMore={false}
      loadMore={() => {}}
      rowProps={({ original }) => ({
        as: 'div',
        'data-testid': `api-key-${original.id}`,
        sx: {
          '& > div > div': {
            display: 'flex',
            alignItems: 'center',
          },
          borderBottom: '1px solid',
          borderBottomColor: 'border.subtle',
        },
      })}
    />
  );
};

ApiKeysDataTable.propTypes = {
  apiKeys: PropTypes.array,
  onClickRevoke: PropTypes.func.isRequired,
};

ApiKeysDataTable.defaultProps = {
  apiKeys: [],
};
